import { combineReducers } from 'redux';

import * as types from '../constants';
import { applyBrandBarberUpdate } from './utils';

const isLoading = (state = false, { type }) => {
  switch (type) {
    case types.GET_SINGLE_BRAND_BARBER:
      return true;
    case types.SET_SINGLE_BRAND_BARBER:
    case types.RESET_SINGLE_BRAND_BARBER:
      return false;
    default:
      return state;
  }
};

const dataByShopId = (state = {}, { type, response, payload }) => {
  switch (type) {
    case types.GET_SINGLE_BRAND_BARBER:
    case types.RESET_SINGLE_BRAND_BARBER:
      return {};
    case types.SET_SINGLE_BRAND_BARBER:
      return response.entities.barberShopData;
    case types.SET_BRAND_BARBER_PERMISSION_CODE:
      return applyBrandBarberUpdate(state, payload);
    case types.ADD_BRAND_BARBER_DAY_OFF: {
      const newDaysOff = state[payload.shopId].days_off ? [...state[payload.shopId].days_off] : [];
      newDaysOff.splice(payload.dayOffIndex, 0, payload.dayOff);
      return {
        ...state,
        [payload.shopId]: {
          ...state[payload.shopId],
          days_off: newDaysOff,
        },
      };
    }
    case types.REMOVE_BRAND_BARBER_DAY_OFF: {
      const newDaysOff = state[payload.shopId].days_off ? [...state[payload.shopId].days_off] : [];
      newDaysOff.splice(payload.dayOffIndex, 1);
      return {
        ...state,
        [payload.shopId]: {
          ...state[payload.shopId],
          days_off: newDaysOff,
        },
      };
    }
    default:
      return state;
  }
};

const shopIds = (state = [], { type, response }) => {
  switch (type) {
    case types.GET_SINGLE_BRAND_BARBER:
    case types.RESET_SINGLE_BRAND_BARBER:
      return [];
    case types.SET_SINGLE_BRAND_BARBER:
      return response.result;
    default:
      return state;
  }
};

const editedBarberId = (state = null, { type, barberId }) => {
  switch (type) {
    case types.GET_SINGLE_BRAND_BARBER:
    case types.RESET_SINGLE_BRAND_BARBER:
      return null;
    case types.SET_SINGLE_BRAND_BARBER:
      return barberId || null;
    default:
      return state;
  }
};

export default combineReducers({
  isLoading,
  barberId: editedBarberId,
  dataByShopId,
  shopIds,
});

